// Speciality labels in older generic Journey source content that are NOT
// separate national patient role cards. Explicitly record the clinically
// appropriate published parent card, while preserving source identity for
// clinical review and specialty-specific variants. Never create a fictitious
// national role, infer an unreviewed scope, or copy a parent's role card into a
// different professional group.
//
// Dosimetrist was intentionally excluded from the generic Radiotherapy role
// list in journeyRoleQuality: retain that choice pending a clinical review.
export const JOURNEY_SPECIALIST_ROLE_MAPPINGS = Object.freeze({
  cardiologist: Object.freeze({parentRoleKey:'consultant',journey:'cardiology'}),
  cardiac_specialist_nurse: Object.freeze({parentRoleKey:'clinical_nurse_specialist',journey:'cardiology'}),
  stroke_consultant: Object.freeze({parentRoleKey:'consultant',journey:'stroke'}),
  stroke_nurse: Object.freeze({parentRoleKey:'clinical_nurse_specialist',journey:'stroke'}),
  orthopaedic_surgeon: Object.freeze({parentRoleKey:'surgeon',variantKey:'orthopaedic_surgeon',journey:'orthopaedics'}),
  neurologist: Object.freeze({parentRoleKey:'consultant',journey:'neurology-neurosurgery'}),
  neurosurgeon: Object.freeze({parentRoleKey:'surgeon',variantKey:'neurosurgeon',journey:'neurology-neurosurgery'}),
  nephrologist: Object.freeze({parentRoleKey:'consultant',journey:'renal'}),
  respiratory_consultant: Object.freeze({parentRoleKey:'consultant',journey:'respiratory'}),
  respiratory_nurse: Object.freeze({parentRoleKey:'clinical_nurse_specialist',journey:'respiratory'}),
  lung_function_physiologist: Object.freeze({parentRoleKey:'respiratory_physiologist',journey:'respiratory'}),
  psychologist: Object.freeze({parentRoleKey:'clinical_psychologist',journey:'mental-health'}),
  clinical_oncologist: Object.freeze({parentRoleKey:'consultant',journey:'radiotherapy'}),
  dosimetrist: Object.freeze({parentRoleKey:null,journey:'radiotherapy',excluded:true,
    reason:'Not in the current clinically scoped generic Radiotherapy people list'}),
  medical_oncologist: Object.freeze({parentRoleKey:'consultant',journey:'chemotherapy'}),
});
export function getJourneySpecialistRoleMapping(roleKey) {
  return JOURNEY_SPECIALIST_ROLE_MAPPINGS[roleKey] || null;
}
